"use client";

import dynamic from "next/dynamic";
import { ContentGateSkeleton } from "./ContentGate";

export type { ContentGateProps } from "./ContentGate";
export { ContentGateSkeleton, useContentGateSuccess } from "./ContentGate";

/**
 * ContentGate with SSR disabled
 * Uses localStorage to check submission status, so must be client-only
 */
export const ContentGate = dynamic(() => import("./ContentGate").then(mod => ({ default: mod.ContentGateClient })), {
  ssr: false,
  loading: () => <ContentGateSkeleton />,
});
